import { PortableText } from "@kontent-ai/rich-text-resolver/utils/react";
import { TopicHero } from "ui-library";
import Section from "../../../components/CMSEnabled/Section/Section";
import GeneralFooter from "../../../components/Footer/GeneralFooter";
import GeneralPageSkeleton from "../../../components/CMSEnabled/GeneralPageSkeleton/GeneralPageSkeleton";
import { generalPage } from "types/CMS/Unum/GeneralPage/generalPage";
import { FC } from "react";
import * as styles from "./CMSTemplate.module.scss";

export type GeneralPageTemplateProps = {
  children?: React.ReactNode;
  loading: {
    isLoading: boolean;
    loadingPlaceholderCount?: number;
    style?: React.CSSProperties;
  };
  sectionClass?: string;
  generalPage?: generalPage;
  showLoadingWhenEmpty?: boolean;
  isError: boolean;
};

const GeneralPageTemplate: FC<GeneralPageTemplateProps> = ({
  children,
  loading,
  isError,
  generalPage,
  sectionClass,
  showLoadingWhenEmpty = true,
}) => {
  return (
    <>
      <div
        style={{
          width: "100%",
          backgroundColor: "rgb(255, 255, 255)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          paddingBottom: "120px",
        }}
        className={"listEnable"}
      >
        {showLoadingWhenEmpty && (!generalPage || isError) && (
          <GeneralPageSkeleton
            style={loading.style}
            count={loading.loadingPlaceholderCount}
          />
        )}
        {!showLoadingWhenEmpty && (!generalPage || isError) && (
          <div style={{ paddingTop: "40px" }}></div>
        )}
        {generalPage && (
          <>
            <TopicHero
              image={generalPage.heroBanner.image.url}
              subtitle={
                <div className={styles.paragraphStyle}>
                  <PortableText {...generalPage.heroBanner.intro} />
                </div>
              }
              title={generalPage.heroBanner.title}
              variant={generalPage.heroBanner.heroType ?? "noImage"}
            
            />
            <div className={`${sectionClass} ${styles.paragraphStyle}`}>
              {generalPage.sections.sections.map((section) => (
                <Section section={section} key={section.key} />
              ))}
            </div>
          </>
        )}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          }}
        >
          {children}
        </div>
      </div>

      <GeneralFooter />
    </>
  );
};

export default GeneralPageTemplate;
